import styled from 'styled-components'

export const StyledLink = styled.a(({ theme }) => ({
  marginRight: '1rem',
  '& > svg': {
    color: theme.colors.n08
  }
}))
